import { render, staticRenderFns } from "./products-resume.vue?vue&type=template&id=017f5f34&scoped=true&lang=pug&"
import script from "./products-resume.vue?vue&type=script&lang=ts&"
export * from "./products-resume.vue?vue&type=script&lang=ts&"
import style0 from "./products-resume.vue?vue&type=style&index=0&id=017f5f34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017f5f34",
  null
  
)

export default component.exports